var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge",class:_vm.classes},[_vm._t("default"),(_vm.$slots.badge)?_c('span',_vm._b({staticClass:"badge__badge",style:(_vm.badgeStyle)},'span',_vm.$attrs,false),[_vm._t("badge")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }